import React from 'react';

const ChurchIcon = (props) => {
  return (
    <img
      alt="Zabytek sakralny"
      src="/static/images/icons/tourist_attractions/church.svg"
      {...props}
    />
  );
};

export default ChurchIcon;
